import { Category } from '@/interfaces';
import clsx from 'clsx';
import {
	Chart,
	GasPump,
	Lock,
	Shop,
	StarShield,
	Stethoscope,
	Tower,
	WarningShield,
} from 'public/icons/tsx';
import { ReactNode } from 'react';

export const getCaseIcon = (type: Category): ReactNode => {
	const formattedType = () => {
		return type?.toLocaleLowerCase().replace(' ', '_');
	};

	const parsedType = formattedType();

	switch (parsedType) {
		case 'whistleblower':
			return <WarningShield className={clsx('!text-[#FF0043]')} />;
		case 'commodities':
			return <GasPump className={clsx('!text-[#A0B245]')} />;
		case 'health_care':
			return <Stethoscope className={clsx('!text-[#2084E7] !w-4')} />;
		case 'securities':
			return <Chart className={clsx('!text-[#EB35CE]')} />;
		case 'antitrust':
			return <Tower className={clsx('!text-[#40BB71]')} />;
		case 'commercial':
			return <Shop className={clsx('!text-[#2D41F5]')} />;
		case 'data_privacy':
			return <Lock className={clsx('!text-[#FD9834]')} />;
		case 'consumer_protection':
			return <StarShield className={clsx('!text-[#8F20EF]')} />;
		default:
			break;
	}
};
